module.exports = __webpack_public_path__ + "img/hamburguesa_bulldog.7b1de960.jpeg";